import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import Images from '../../constants/Images';
import { useDispatch } from 'react-redux';
import { GENERAL_ACTIONS } from '../../constants/actionTypes';
import { useLocalStorage } from '../../services';
const Navbar = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const dispatch = useDispatch();


  const [lightMode, setLightMode] = useLocalStorage('lightMode', false);

  const storedLightMode = localStorage.getItem('lightMode');
  console.log(" Darkmode ", storedLightMode);
  
  
 

  const toggleDrawer = () => {
    setShowDrawer(!showDrawer);
  };

  const closeDrawer = () => {
    setShowDrawer(false);
  };

  const toggleDarkMode = () => {
    console.log("working..")
    
    setLightMode(!lightMode);
    dispatch({
      type: GENERAL_ACTIONS.LIGHT_MODE,
      payload:!lightMode
    });
    
    
  
  };

  
  
  

  return (
    <nav className={`flex justify-between items-center px-5 py-2 w-full text-base font-semibold  bg-blue-950 text-white  sm:flex-wrap sm:px-5 sm:max-w-full`}>
      <div className="flex items-center">
        <img loading="lazy" src={Images.LOGO} alt="Business Logo" className="h-14 w-auto md:px-20 cursor-pointer" />
      </div>
      <div className="ml-auto items-center flex justify-center gap-5  md:hidden">
      
        <FontAwesomeIcon icon={lightMode ? faSun : faMoon} color='yellow' className="text-2xl cursor-pointer" onClick={toggleDarkMode} />
      
        <FontAwesomeIcon  icon={faBars} className='cursor-pointer ' size='lg' onClick={toggleDrawer} />
      </div>

      <div className={`md:flex md:items-center ${showDrawer ? 'block' : 'hidden'}`}>
        <div className={`flex gap-10 px-5 ${showDrawer ? 'hidden' : 'block'}`}>
          <a href="/" className={"text-gray-100"} onClick={closeDrawer}>Home</a>
          <a href="/service" className={"text-gray-100"} onClick={closeDrawer}>Service</a>
          <a href="/works" className={"text-gray-100"} onClick={closeDrawer}>Our Works</a>
          <a href="/about" className={"text-gray-100"} onClick={closeDrawer}>About Us</a>
          <a href="/contactus" className={"text-gray-100"} onClick={closeDrawer}>Contact Us</a>
          <a href="/login" className={"text-gray-100"} onClick={closeDrawer}>Login</a>
        </div>
        <div className={`flex items-center ${!showDrawer ? 'block' : 'hidden'}`}>
        <FontAwesomeIcon
      icon={!lightMode ? faSun : faMoon}
      color='yellow'
      className={`text-2xl w-10 cursor-pointer ${!lightMode ? ' rotate rotate-180' : 'fade-in'}`}
      onClick={toggleDarkMode}
    />
     
      </div>
      </div>
      

      {showDrawer && (
        <div className="fixed inset-0 bg-black bg-opacity-25 z-50"></div>
      )}
      <div className={`md:hidden fixed inset-y-0 right-0 w-64 bg-white z-50 shadow-lg h-full transition duration-300 ease-in-out transform ${showDrawer ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex justify-end px-4 py-2">
          <FontAwesomeIcon icon={faTimes} className="text-2xl cursor-pointer" color='red'  onClick={closeDrawer} /> 
        </div>
        <div className="flex flex-col gap-5 px-4 pt-2">
          <a href="/" className={lightMode ? "text-gray-700" : "text-gray-800"} onClick={closeDrawer}>Home</a>
          <a href="/service" className={lightMode ? "text-gray-700" : "text-gray-800"} onClick={closeDrawer}>Service</a>
          <a href="/works" className={lightMode ? "text-gray-700" : "text-gray-800"} onClick={closeDrawer}>Our Works</a>
          <a href="/about" className={lightMode ? "text-gray-700" : "text-gray-800"} onClick={closeDrawer}>About Us</a>
          <a href="/contact" className={lightMode ? "text-gray-700" : "text-gray-800"} onClick={closeDrawer}>Contact Us</a>
          <a href="/login" className={lightMode ? "text-gray-700" : "text-gray-800"} onClick={closeDrawer}>Login</a>
        </div>
      </div>

     
    </nav>
  );
};

export default Navbar;
